var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-internal-loader",class:_vm.loaderCLasses},_vm._l((_vm.ellipsesAmount),function(ellipse){return _c('div',{key:ellipse,staticClass:"our-internal-loader-ellipse",class:_vm.ellipseClasses})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }